import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { BsExclamationTriangleFill, BsCheckCircleFill } from "react-icons/bs";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  ACADEMICYEARID,
  baseURL,
  CHAPTERID,
  PAYMENTMONTH,
} from "../../API/API";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  faArrowRight,
  faCircleXmark,
  faCircleCheck,
  faTrophy,
  faLock,
  faEye,
  faBook,
  faExclamationTriangle,
  faMessage,
  faChevronDown,
  faChevronUp,
  faUnlock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Learn.css";
import { toast } from "react-toastify";
import SendMessageCart from "../../Components/common/SendMessageCart";
import { useDataRefresh } from "../context/DataRefreshContext";

// Local helper to fetch static image or course dynamic image
import Img1 from "../../Imge/1.png";
import Img2 from "../../Imge/2.png";
import Img3 from "../../Imge/3.png";
import Img4 from "../../Imge/4.png";
import Img5 from "../../Imge/5.png";
import Img6 from "../../Imge/6.png";
import FallbackImg from "../../Imge/about_2.png";
import L1Img from "../../Imge/l1.png";
import L2Img from "../../Imge/l2.png";

const fallbackStages = [
  { id: 1, name: "الصف الأول الثانوي", academic_type: "general" },
  { id: 2, name: "الصف الثاني الثانوي", academic_type: "general" },
  { id: 3, name: "الصف الثالث الثانوي", academic_type: "general" },
  { id: 4, name: "الصف الأول الثانوي أزهري", academic_type: "azhar" },
  { id: 5, name: "الصف الثاني الثانوي أزهري", academic_type: "azhar" },
  { id: 6, name: "الصف الثالث الثانوي أزهري", academic_type: "azhar" },
];

const isAzharStage = (stage) => {
  const name = stage?.name?.toLowerCase() || "";
  const type = stage?.academic_type?.toLowerCase() || "";
  return (
    type === "azhar" ||
    name.includes("أزهر") ||
    name.includes("ازهر")
  );
};

const getGradeOrder = (name) => {
  const n = name?.toLowerCase() || "";
  if (n.includes("أول") || n.includes("اول") || n.includes("1")) return 1;
  if (n.includes("ثان") || n.includes("تان") || n.includes("2")) return 2;
  if (n.includes("ثالث") || n.includes("تالت") || n.includes("3")) return 3;
  return 4;
};

const getStageImage = (stage) => {
  if (stage?.image_path) return stage.image_path;
  if (!stage) return FallbackImg;

  // ✅ استخدم الـ id مباشرة لو موجود
  const numId = Number(stage.id);
  if (numId === 1) return Img1;
  if (numId === 2) return Img2;
  if (numId === 3) return Img3;
  if (numId === 4) return Img4;
  if (numId === 5) return Img5;
  if (numId === 6) return Img6;

  // fallback على الاسم لو الـ id مش من 1 لـ 6
  const azhar = isAzharStage(stage);
  const grade = getGradeOrder(stage.name);
  if (!azhar) {
    if (grade === 1) return Img1;
    if (grade === 2) return Img2;
    if (grade === 3) return Img3;
  } else {
    if (grade === 1) return Img4;
    if (grade === 2) return Img5;
    if (grade === 3) return Img6;
  }
  return FallbackImg;
};

const getCourseDetails = (stage) => {
  if (!stage) return null;
  
  const name = stage.name || "";
  let price = 150;
  let description = stage.description || "شرح وتأسيس متكامل للمناهج الدراسية لطلاب الثانوية العامة والأزهرية، بأسلوب يجمع بين التبسيط والعمق الأكاديمي.";
  let image = stage.image_path || FallbackImg;
  
  if (stage.price !== undefined && stage.price !== null) {
    price = Number(stage.price);
  } else if (name.includes("معسكر النحو الشامل") && (name.includes("عام") || name.includes("العام"))) {
    price = 250;
    description = "معسكر النحو الشامل لطلاب الثانوية العامة - شرح كامل وتدريبات مكثفة على جميع قواعد النحو والاعراب.";
    image = L1Img;
  } else if (name.includes("معسكر النحو الشامل") && (name.includes("أزهر") || name.includes("ازهر"))) {
    price = 250;
    description = "معسكر النحو الشامل لطلاب الثانوية الأزهرية - شرح كامل وتدريبات مكثفة متوافقة مع منهج الأزهر الشريف.";
    image = L2Img;
  } else {
    if (name.includes("الأول") || name.includes("اول")) {
      price = 125;
    } else if (name.includes("الثاني") || name.includes("تانى") || name.includes("ثانى")) {
      price = 150;
    } else if (name.includes("الثالث") || name.includes("تالت")) {
      price = 200;
    }
    image = getStageImage(stage);
  }
  
  return {
    id: stage.id,
    name: name,
    price: price,
    description: description,
    image: image,
    academic_type: stage.academic_type,
  };
};

export default function Learn() {
  const [chapters, setChapters] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(null);
  const [Lesons, setLesons] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [currentLockedChapter, setCurrentLockedChapter] = useState(null);
  const lockedChapterRef = useRef(null);
  const [isPaying, setIsPaying] = useState(false);
  const [showMessageCard, setShowMessageCard] = useState(false);
  const { auth, setAuth } = useAuth();
  const { refreshKey, triggerRefresh } = useDataRefresh();

  // Course Details State
  const [course, setCourse] = useState(null);
  const [expandedChapterId, setExpandedChapterId] = useState(null);
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  const [filteredChapters, setFilteredChapters] = useState([]);
  const [settings, setSettings] = useState({
    payment_number: "01031360031",
    support_phone: "01031360031",
  });

  useEffect(() => {
    async function fetchSettings() {
      try {
        const response = await axiosPrivate.get(`${baseURL}/learning/settings`);
        if (response.data?.data) {
          setSettings(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching settings for Learn page:", error);
      }
    }
    fetchSettings();
  }, [axiosPrivate]);

  // جلب معلومات الكورس
  useEffect(() => {
    async function fetchCourseDetails() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/learning/academics`);
        const data = res.data?.data || [];
        const found = data.find((c) => Number(c.id) === Number(id));
        if (found) {
          setCourse(getCourseDetails(found));
        } else {
          // Fallback static course if not in API list
          const fallbackStage = fallbackStages.find((s) => Number(s.id) === Number(id));
          const name = fallbackStage ? fallbackStage.name : "كورس اللغة العربية الشامل - منصة نوح التعليمية";
          setCourse(getCourseDetails(fallbackStage || { id: Number(id), name }));
        }
      } catch (error) {
        console.error("خطأ في جلب بيانات الكورس:", error);
        const fallbackStage = fallbackStages.find((s) => Number(s.id) === Number(id));
        const name = fallbackStage ? fallbackStage.name : "كورس اللغة العربية الشامل - منصة نوح التعليمية";
        setCourse(getCourseDetails(fallbackStage || { id: Number(id), name }));
      }
    }

    if (id) {
      fetchCourseDetails();
    }
  }, [id, axiosPrivate]);

  // جلب الفصول
  useEffect(() => {
    async function fetchChapters() {
      try {
        const queryParams = new URLSearchParams(window.location.search);
        const urlTeacherId = queryParams.get("teacher_id");
        const res = await axiosPrivate.get(`${baseURL}/${ACADEMICYEARID}/${id}`, { params: urlTeacherId ? { teacher_id: urlTeacherId } : {} });
        const fetchedChapters = res.data.data || [];
        setChapters(fetchedChapters);

        // Extract unique teachers and set initial selected teacher
        const teachersInStage = [];
        const seen = new Set();
        fetchedChapters.forEach(ch => {
          const tId = ch.teacher_id ? String(ch.teacher_id) : "admin";
          const tName = ch.teacher?.name || "المدرس الأساسي";
          if (!seen.has(tId)) {
            seen.add(tId);
            teachersInStage.push({ id: tId, name: tName });
          }
        });

        if (urlTeacherId && seen.has(String(urlTeacherId))) {
          setSelectedTeacherId(String(urlTeacherId));
        } else if (teachersInStage.length > 0) {
          setSelectedTeacherId(teachersInStage[0].id);
        } else {
          setSelectedTeacherId("admin");
        }
      } catch (error) {
        console.error("خطأ في جلب الفصول:", error);
        toast.error("فشل تحميل الفصول");
        setChapters([]);
      }
    }

    if (id) {
      fetchChapters();
    }
  }, [id, refreshKey, axiosPrivate]);

  const refetchChapters = useCallback(async () => {
    if (!id) return;
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const urlTeacherId = queryParams.get("teacher_id");
      const res = await axiosPrivate.get(`${baseURL}/${ACADEMICYEARID}/${id}`, { params: urlTeacherId ? { teacher_id: urlTeacherId } : {} });
      setChapters(res.data.data || []);
    } catch (error) {
      console.error("خطأ في إعادة جلب الفصول:", error);
    }
  }, [axiosPrivate, id]);

  // Effect to filter chapters by selectedTeacherId and handle auto expansion
  useEffect(() => {
    const list = chapters.filter(ch => {
      const tId = ch.teacher_id ? String(ch.teacher_id) : "admin";
      return tId === String(selectedTeacherId);
    });
    setFilteredChapters(list);

    // Auto expand first accessible chapter in filtered list
    if (list.length > 0) {
      const isAcc = (idx) => {
        const current = list[idx];
        if (!current) return false;
        return auth?.user?.is_staff || Boolean(current.has_accessed);
      };

      let foundIdx = -1;
      for (let i = 0; i < list.length; i++) {
        if (isAcc(i)) {
          foundIdx = i;
          break;
        }
      }

      if (foundIdx !== -1) {
        const firstAccessible = list[foundIdx];
        setSelectedId(firstAccessible.id);
        setSelectedChapterName(firstAccessible.name);
        setExpandedChapterId(firstAccessible.id);
      } else {
        setExpandedChapterId(list[0].id);
        setSelectedId(null);
      }
    } else {
      setSelectedId(null);
      setExpandedChapterId(null);
    }
  }, [chapters, selectedTeacherId]);

  // جلب الدروس للشهر/الوحدة المحددة
  useEffect(() => {
    async function fetchLessons() {
      try {
        if (selectedId !== null) {
          const res = await axiosPrivate.get(`${baseURL}/${CHAPTERID}/${selectedId}`);
          setLesons(res.data.data || []);
        }
      } catch (error) {
        console.error("خطأ في جلب الدروس:", error);
        toast.error("فشل تحميل الدروس");
        setLesons([]);
      }
    }

    fetchLessons();
  }, [selectedId, refreshKey, axiosPrivate]);

  // الدفع/الاشتراك من الرصيد المتوفر بالحساب
  async function handelPayment() {
    const chapter = lockedChapterRef.current ?? currentLockedChapter;
    const chapterId = Number(chapter?.id);
    if (!chapterId || isPaying) return;

    const toastId = "payment";
    setIsPaying(true);
    toast.loading("جاري تنفيذ عملية الاشتراك...", {
      toastId,
      autoClose: false,
    });

    try {
      const response = await axiosPrivate.post(`${baseURL}/${PAYMENTMONTH}`, {
        paymentID: chapterId,
      });

      const message = response.data?.message || "تم الاشتراك بنجاح";

      if (response.data?.credit !== undefined) {
        setAuth((prev) => ({
          ...prev,
          user: {
            ...prev?.user,
            credit: response.data.credit,
          },
        }));
      }

      setChapters((prev) =>
        prev.map((ch) =>
          Number(ch.id) === chapterId ? { ...ch, has_accessed: true } : ch
        )
      );

      toast.dismiss(toastId);
      toast.success(`✅ ${message}`, { toastId, autoClose: 4000 });

      setShowSubscribeModal(false);
      triggerRefresh();
      setSelectedId(chapterId);
      setExpandedChapterId(chapterId);
      const paidChapterName = lockedChapterRef.current?.name ?? chapter?.name;
      if (paidChapterName) {
        setSelectedChapterName(paidChapterName);
      }

      try {
        await refetchChapters();
      } catch (refetchError) {
        console.error("تعذر تحديث قائمة الوحدات بعد الدفع:", refetchError);
      }
    } catch (error) {
      console.error("حدث خطأ أثناء التحقق من الدفع:", error);
      toast.dismiss(toastId);

      if (
        error?.response?.status === 400 ||
        error?.response?.status === 401
      ) {
        const errorMsg =
          error?.response?.data?.message || "لا يمكنك الاشتراك في هذا الوقت";
        toast.error(`❌ ${errorMsg}`, { toastId, autoClose: 5000 });
      } else {
        toast.error("❌ رصيدك غير كافي. الرجاء الذهاب لصفحة الفواتير لشحن الرصيد والتحويل.", {
          toastId,
          autoClose: 5000,
        });
      }
    } finally {
      setIsPaying(false);
    }
  }

  const canAccess = (index) => {
    if (auth?.user?.is_staff) return true;
    const current = filteredChapters[index];
    if (!current) return false;

    // Any unit that the student is subscribed to (has_accessed) is unlocked & accessible
    return Boolean(current.has_accessed);
  };

  const handleChapterToggle = (item, index) => {
    const accessible = canAccess(index);

    if (!item?.has_accessed && !auth?.user?.is_staff) {
      lockedChapterRef.current = item;
      setCurrentLockedChapter(item);
      setShowSubscribeModal(true);
      setExpandedChapterId(item.id);
      return;
    }

    // Toggle expansion
    if (expandedChapterId === item.id) {
      setExpandedChapterId(null);
    } else {
      setSelectedId(item.id);
      setSelectedChapterName(item.name);
      setExpandedChapterId(item.id);
    }
  };
  const selectedTeacher = chapters.find(ch => String(ch.teacher_id || "admin") === String(selectedTeacherId))?.teacher;
  const teacherSubject = selectedTeacher?.subject;
  const teacherName = selectedTeacher?.name;

  const dynamicDesc = teacherSubject && teacherName
    ? `شرح وتأسيس متكامل لمادة ${teacherSubject} مع الأستاذ ${teacherName} لضمان التميز وتحقيق الدرجة النهائية.`
    : teacherSubject
      ? `شرح وتأسيس متكامل لمادة ${teacherSubject} مع نخبة من كبار المعلمين والأساتذة المتخصصين.`
      : "شرح وتأسيس متكامل للمنهج الدراسي مع نخبة من كبار المعلمين والأساتذة المتخصصين لضمان تفوقك الأكاديمي.";

  return (
    <div className="LearnPage custom-redesign" dir="rtl">
      <Header />

      {/* Top Premium Purple Banner */}
      <div className="learn-purple-banner py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-4">
            <div className="banner-content text-end">
              <h1 className="banner-title fw-bold mb-3">{course?.name || "كورسات المرحلة التعليمية"}</h1>
              <p className="banner-desc mb-2">{dynamicDesc}</p>
              <div className="banner-technical-support small">
                <span>لو بيقابلك صعوبة في الاشتراك او للاشتراك بفودافون كاش</span>
                <br />
                <span>ابعت رسالة لتيم الدعم الفني علي واتساب او التليجرام علي الرقم <strong style={{ color: "var(--brand-200-alt)" }}>{settings.support_phone}</strong> او كلمنا فون علي الرقم دا <strong style={{ color: "var(--brand-200-alt)" }}>{settings.support_phone}</strong></span>
              </div>
            </div>
            <Link to="/courses" className="btn btn-banner-back d-flex align-items-center gap-2 text-decoration-none">
              <span>العودة</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </Container>
      </div>

      <Container className="my-5">
        <Row className="g-4">

          {/* RIGHT COLUMN: Accordion Chapters & Lessons (matches Screenshot 3, first in HTML so it goes right in RTL) */}
          <Col lg={8}>
            <div className="lessons-section-wrapper text-end">
              <h2 className="section-main-title fw-bold mb-4">الدروس</h2>

              {filteredChapters.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <p>لا توجد وحدات متوفرة لهذا المدرس حالياً.</p>
                </div>
              ) : (
                <div className="chapters-accordion-wrapper d-flex flex-column gap-3">
                  {filteredChapters.map((item, index) => {
                    const score = Math.min(100, Math.max(0, parseFloat(item.score) || 0));
                    const isPassed = score >= 70;
                    const isSubmitted = item.submitted_at;
                    const isSubscribed = item.has_accessed || auth?.user?.is_staff;
                    const accessible = canAccess(index);
                    const isExpanded = expandedChapterId === item.id;

                    let icon = faEye;
                    let iconColor = "#6c757d"; // default gray
                    if (!isSubscribed) {
                      icon = faLock;
                      iconColor = "#7c3aed"; // purple-locked
                    } else if (isPassed) {
                      icon = faCircleCheck;
                      iconColor = "var(--brand-200-alt, #cca245)";
                    } else if (isSubmitted) {
                      icon = faCircleXmark;
                      iconColor = "#dc3545"; // red
                    } else {
                      icon = faEye;
                      iconColor = "#17a2b8"; // sky blue
                    }

                    return (
                      <div key={item.id} className={`chapter-accordion-item rounded-3 shadow-sm border ${isExpanded ? "active" : ""}`}>
                        {/* Header Box */}
                        <div
                          className="accordion-header-box d-flex justify-content-between align-items-center p-3 cursor-pointer"
                          onClick={() => handleChapterToggle(item, index)}
                          style={{
                            backgroundColor: isExpanded ? "rgba(124, 58, 237, 0.08)" : "#ffffff"
                          }}
                        >
                          <div className="d-flex align-items-center gap-3">
                            <FontAwesomeIcon icon={icon} style={{ color: iconColor, fontSize: "20px" }} />
                            <div>
                              <h5 className="chapter-title fw-bold m-0 text-dark">
                                {item.name || "الوحدة"}
                                {item.has_accessed ? (
                                  <span className="badge bg-success-light text-success ms-2 small-badge">
                                    <FontAwesomeIcon icon={faUnlock} className="me-1" /> مشترك
                                  </span>
                                ) : (
                                  <span className="badge bg-warning-light text-warning ms-2 small-badge">
                                    <FontAwesomeIcon icon={faLock} className="me-1" /> غير مشترك
                                  </span>
                                )}
                              </h5>
                              <div className="small text-muted mt-1">
                                {isSubscribed ? (isPassed ? "مكتملة" : isSubmitted ? "قيد التقييم" : "متاحة") : "غير مشترك - اضغط للاشتراك"}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            {/* Score info */}
                            <span className="small text-muted font-bold">
                              {item.score !== null && item.score !== undefined ? `تم اجتياز ${score}%` : "لم يُختبر بعد"}
                            </span>
                            <FontAwesomeIcon
                              icon={isExpanded ? faChevronUp : faChevronDown}
                              className="text-muted"
                              style={{ fontSize: "14px" }}
                            />
                          </div>
                        </div>

                        {/* Collapsible Content */}
                        {isExpanded && (
                          <div className="accordion-body-box p-3 border-top bg-light-purple">
                            {/* Chapter Progress bar */}
                            <div className="mb-4">
                              <div
                                className="chapter-progress-track rounded-pill"
                                style={{ height: "8px", backgroundColor: "#e2e8f0", overflow: "hidden" }}
                              >
                                <div
                                  className={`chapter-progress-fill h-100 ${isPassed ? "bg-success" : "bg-primary"}`}
                                  style={{ width: `${score}%`, transition: "width 0.4s ease" }}
                                />
                              </div>
                            </div>

                            {/* Lessons List inside accordion */}
                            {selectedId === item.id && (
                              <div className="lessons-container d-flex flex-column gap-3">
                                {Lesons && Lesons.length > 0 ? (
                                  Lesons.map((lesson, idx) => (
                                    <Card key={lesson.id} className="lesson-item-card border-0 shadow-sm p-3">
                                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                        <div className="d-flex align-items-center gap-3">
                                          <div className="lesson-number-badge d-flex align-items-center justify-content-center bg-purple-light text-purple rounded-circle" style={{ width: "36px", height: "36px" }}>
                                            {idx + 1}
                                          </div>
                                          <div>
                                            <h6 className="fw-bold m-0 text-dark">{lesson.lesson_name || lesson.name}</h6>
                                            <p className="small text-muted m-0 mt-1">{lesson.lesson_description || lesson.description || "شرح مبسط ومكثف للدرس"}</p>
                                          </div>
                                        </div>
                                        <Link
                                          to={`/lesson/${lesson.id}`}
                                          state={{ academicYearId: id, chapterId: selectedId }}
                                          className="text-decoration-none"
                                        >
                                          <button className="btn btn-start-lesson d-flex align-items-center gap-2 rounded-pill px-3 py-2 text-white">
                                            <span>ابدأ الدرس</span>
                                            <FontAwesomeIcon icon={faBook} />
                                          </button>
                                        </Link>
                                      </div>
                                    </Card>
                                  ))
                                ) : (
                                  <Card className="p-4 text-center border-0 shadow-sm">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-warning mb-2" style={{ fontSize: "24px" }} />
                                    <p className="m-0 text-muted small">لا توجد دروس متوفرة في هذا الشهر حالياً.</p>
                                  </Card>
                                )}

                                {/* Unit Exam Card */}
                                <Card className="exam-card border-0 shadow-sm p-3 mt-2 bg-gradient-purple text-white">
                                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                    <div>
                                      <h5 className="fw-bold m-0">امتحان الشهر / الوحدة</h5>
                                      <p className="small m-0 mt-1 opacity-90">تأكد من استيعابك لكافة الدروس قبل خوض الاختبار التقييمي.</p>
                                    </div>
                                    <Link
                                      to={`/exam/${selectedId}`}
                                      state={{ id }}
                                      className="text-decoration-none"
                                    >
                                      <button className="btn btn-start-exam d-flex align-items-center gap-2 rounded-pill px-4 py-2 bg-white text-purple fw-bold">
                                        <span>اختبر فهمك</span>
                                        <FontAwesomeIcon icon={faTrophy} className="text-warning" />
                                      </button>
                                    </Link>
                                  </div>
                                </Card>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Col>

          {/* LEFT COLUMN: Premium Course Details / Progress Card */}
          <Col lg={4}>
            {(() => {
              const activeChapter = chapters.find((ch) => Number(ch.id) === Number(selectedId))
                                 || chapters.find((ch) => Number(ch.id) === Number(expandedChapterId))
                                 || chapters[0];
              const isPurchased = activeChapter ? Boolean(activeChapter.has_accessed) : false;

              if (isPurchased) {
                // حساب تقدم مشاهدة الدروس
                const userKey = auth?.user?.email || "guest";
                const completedLessonsCount = Lesons.filter(
                  (lesson) => localStorage.getItem(`completed-lesson-${userKey}-${lesson.id}`) === "true"
                ).length;
                const totalLessonsCount = Lesons.length;
                const completionRate = totalLessonsCount > 0
                  ? Math.round((completedLessonsCount / totalLessonsCount) * 100)
                  : 0;

                const score = activeChapter.score !== null ? parseFloat(activeChapter.score) : null;
                const isPassed = score !== null && score >= 70;

                // إيجاد الدرس التالي للمتابعة منه
                const nextToStudy = Lesons.find(
                  (lesson) => localStorage.getItem(`completed-lesson-${userKey}-${lesson.id}`) !== "true"
                ) || Lesons[0];

                return (
                  <Card className="course-summary-card progress-sidebar-card border-0 shadow-sm overflow-hidden p-0 rounded-4">
                    <div className="course-image-wrapper position-relative" style={{ height: "200px" }}>
                      <img
                        src={resolveMediaUrl(activeChapter?.image_path) || course?.image || FallbackImg}
                        alt={course?.name}
                        className="w-100 h-100 object-fit-cover"
                      />
                      <div className="progress-badge-overlay">
                        <span>الوحدة مفعلة ✅</span>
                      </div>
                    </div>
                    <Card.Body className="p-4 text-end">
                      <h5 className="fw-bold text-dark mb-4">{activeChapter.name}</h5>

                      {/* مؤشر تقدم مشاهدة الدروس */}
                      <div className="progress-stat-box mb-4">
                        <div className="d-flex justify-content-between mb-2">
                          <span className="fw-bold text-primary">{completionRate}%</span>
                          <span className="text-muted small">تقدم مشاهدة الدروس:</span>
                        </div>
                        <div className="progress" style={{ height: "10px", borderRadius: "5px", overflow: "hidden" }}>
                          <div
                            className="progress-bar bg-success progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            style={{ width: `${completionRate}%` }}
                            aria-valuenow={completionRate}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div className="text-muted small mt-2 text-start">
                          شاهدت {completedLessonsCount} من أصل {totalLessonsCount} درس
                        </div>
                      </div>

                      {/* حالة الاختبار التقييمي */}
                      <div className="exam-status-box mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}>
                        <span className="d-block fw-bold text-dark mb-2 small">حالة اختبار الوحدة:</span>
                        {score !== null ? (
                          <div>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <span className={`fw-bold ${isPassed ? "text-success" : "text-danger"}`}>{score}%</span>
                              <span className="small text-muted">الدرجة المحققة:</span>
                            </div>
                            {isPassed ? (
                              <span className="text-success small fw-bold">✓ اجتزت الاختبار بنجاح</span>
                            ) : (
                              <span className="text-danger small fw-bold">⚠️ لم تحقق درجة الاجتياز (70%). يرجى إعادة الاختبار.</span>
                            )}
                          </div>
                        ) : (
                          <span className="text-muted small">لم تؤدِّ الاختبار التقييمي لهذه الوحدة بعد.</span>
                        )}
                      </div>

                      {/* أزرار التفاعل السريع */}
                      {nextToStudy ? (
                        <Link
                          to={`/lesson/${nextToStudy.id}`}
                          state={{ academicYearId: id, chapterId: selectedId }}
                          className="text-decoration-none"
                        >
                          <button className="btn btn-subscribe-now w-100 rounded-3 py-3 fw-bold fs-6 mb-2">
                            متابعة الدراسة 📖
                          </button>
                        </Link>
                      ) : (
                        totalLessonsCount > 0 && (
                          <Link
                            to={`/lesson/${Lesons[0].id}`}
                            state={{ academicYearId: id, chapterId: selectedId }}
                            className="text-decoration-none"
                          >
                            <button className="btn btn-subscribe-now w-100 rounded-3 py-3 fw-bold fs-6 mb-2">
                              مراجعة الدروس 🔁
                            </button>
                          </Link>
                        )
                      )}
                    </Card.Body>
                  </Card>
                );
              }

              // الكارت الافتراضي لشراء الاشتراك
              return (
                <Card className="course-summary-card border-0 shadow-sm overflow-hidden p-0 rounded-4">
                  <div className="course-image-wrapper" style={{ height: "240px" }}>
                    <img
                      src={resolveMediaUrl(activeChapter?.image_path) || course?.image || FallbackImg}
                      alt={activeChapter?.name || course?.name}
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <Card.Body className="p-4 text-end">
                    {Number(activeChapter?.discount) > 0 ? (
                      <div className="course-card-price text-end w-100 mb-3 border-bottom pb-3" style={{ direction: "rtl" }}>
                        <div className="text-primary-500 fw-bold text-end mb-1" style={{ color: "var(--brand-300)", fontSize: "2.1rem" }}>
                          {Number(activeChapter?.price || 150) - Number(activeChapter?.discount)} جنيه
                        </div>
                        <div className="d-flex flex-row gap-1 justify-content-end align-items-center text-muted small" style={{ fontSize: "0.95rem" }}>
                          <span className="text-gray-600 dark:text-gray-200 smooth opacity-75">بدلاً من</span>
                          <span className="text-decoration-line-through text-danger fw-semibold" style={{ color: "#dc3545", fontWeight: "600" }}>{activeChapter?.price || 150} جنيهاً</span>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-baseline gap-2 justify-content-end mb-3 border-bottom pb-3">
                        <span className="price-label text-muted small">سعر الكورس:</span>
                        <span className="price-amount fw-bold text-primary" style={{ fontSize: "2.3rem" }}>{activeChapter?.price || course?.price || 150}</span>
                        <span className="price-currency small text-muted font-bold">جنيه</span>
                      </div>
                    )}

                    <div className="course-support-details-box text-end mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}>
                      <h4 className="fw-bold text-dark mb-3 fs-5" style={{ lineHeight: "1.5" }}>
                        {activeChapter?.name || course?.name || "كورس اللغة العربية الشامل - منصة نوح التعليمية"}
                      </h4>

                      <div className="support-instruction-text text-muted" style={{ fontSize: "0.95rem", lineHeight: "1.8" }}>
                        <p className="fw-bold text-primary mb-2">لو بيقابلك صعوبة في الاشتراك او للاشتراك بفودافون كاش:</p>
                        <p className="m-0 mb-2">
                          ابعت رسالة لتيم الدعم الفني علي <strong>واتساب</strong> او <strong>التليجرام</strong> علي الرقم:
                          <br />
                          <strong className="fs-5 text-dark d-block my-1 text-center" style={{ letterSpacing: "1px" }}>{settings.support_phone}</strong>
                        </p>
                        <p className="m-0">
                          او كلمنا فون علي الرقم دا:
                          <br />
                          <strong className="fs-5 text-dark d-block mt-1 text-center" style={{ letterSpacing: "1px" }}>{settings.support_phone}</strong>
                        </p>
                      </div>
                    </div>

                    {/* Orange/Yellow subscribe button like Screenshot 2 */}
                    <Link
                      to={`/invoice/${activeChapter?.id || id}`}
                      state={{
                        price: activeChapter?.price || course?.price || 150,
                        discount: activeChapter?.discount || 0,
                        courseName: activeChapter?.name || course?.name,
                      }}
                      className="text-decoration-none"
                    >
                      <button className="btn btn-subscribe-now w-100 rounded-3 py-3 fw-bold fs-5 mb-2">
                        اشترك الان !
                      </button>
                    </Link>
                  </Card.Body>
                </Card>
              );
            })()}
          </Col>

        </Row>

        {/* Subscribe popup if clicking locked month */}
        {showSubscribeModal && !auth?.user?.is_staff && (
          <div className="custom-modal-overlay">
            <div className="custom-modal-content text-end">
              <h3 className="fw-bold mb-3 d-flex align-items-center gap-2 justify-content-start flex-row-reverse">
                <BsExclamationTriangleFill className="text-warning" style={{ fontSize: "28px" }} />
                <span>هذا الشهر غير متاح</span>
              </h3>
              <div className="mb-4">
                <p className="m-0 mb-2">الرجاء شحن حسابك والاشتراك أولاً للوصول إلى محتوى هذا الشهر.</p>
                {Number(currentLockedChapter?.discount) > 0 ? (
                  <div className="fw-bold m-0" style={{ direction: "rtl" }}>
                    <span>قيمة اشتراك هذا الشهر هي: </span>
                    <span className="text-danger fs-5 fw-bold">{(Number(currentLockedChapter?.price || 150) - Number(currentLockedChapter?.discount))} جنيه </span>
                    <span className="text-muted small" style={{ fontSize: "0.88rem" }}>
                      بدلاً من <span className="text-danger text-decoration-line-through" style={{ color: "#dc3545", fontWeight: "500" }}>{currentLockedChapter?.price || 150} جنيهاً</span>
                    </span>
                  </div>
                ) : (
                  <p className="fw-bold m-0 text-primary">
                    قيمة اشتراك هذا الشهر هي: {currentLockedChapter?.price || 150} جنيه فقط.
                  </p>
                )}
                <p className="text-muted small mt-2">
                  عند التحويل عبر فودافون كاش أو انستا باي، يتم إضافة الرصيد إلى حسابك ثم النقر على زر "اشترك الآن" بداخل الحساب لتفعيل الشهر فوراً.
                </p>
              </div>

              <div className="d-flex justify-content-end gap-3">
                <Link
                  to={`/invoice/${currentLockedChapter?.id || id}`}
                  state={{
                    price: currentLockedChapter?.price ?? 150,
                    discount: currentLockedChapter?.discount ?? 0,
                    courseName: currentLockedChapter?.name,
                  }}
                  className="text-decoration-none"
                >
                  <button className="btn btn-primary px-4 py-2 rounded-3">
                    الذهاب لصفحة الفواتير
                  </button>
                </Link>

                <button
                  type="button"
                  className="btn btn-success px-4 py-2 rounded-3"
                  disabled={isPaying}
                  onClick={handelPayment}
                >
                  {isPaying ? "جاري التفعيل..." : "تفعيل من الرصيد"}
                </button>

                <button
                  className="btn btn-outline-danger px-4 py-2 rounded-3"
                  onClick={() => setShowSubscribeModal(false)}
                >
                  إغلاق
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Messaging button floating */}
        <div
          className="chat message-icone-learn"
          dir="ltr"
          style={{ cursor: "pointer" }}
          onClick={() => setShowMessageCard(true)}
        >
          <FontAwesomeIcon
            style={{ color: "#FFFFFF" }}
            icon={faMessage}
            className="fw-bold message-icon-heder"
          />
        </div>
      </Container>

      <Footer />

      {showMessageCard && (
        <div
          className="learn-message-overlay"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
          onClick={() => setShowMessageCard(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <SendMessageCart
              setmessage={setShowMessageCard}
              message={showMessageCard}
              chapterId={selectedId}
            />
          </div>
        </div>
      )}
    </div>
  );
}
